import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  GcButtonComponent,
  GcInputFieldComponent,
  IpoTranslatePipe,
} from '@ip-only/front-end-library';
import { ReportSelfInspectionWrapperComponent } from '../components/report-self-inspection-wrapper/report-self-inspection-wrapper.component';
import { SaveButtonsComponent } from '../components/save-buttons/save-buttons.component';
import {
  ListInputData,
  SelfInspcetionWrapperData,
} from '../report-input-entities';
import { SelfInspectionBaseClassComponent } from '../self-inspection-base-class/self-inspection-base-class.component';

@Component({
  selector: 'app-self-inspection-list',
  imports: [
    ReportSelfInspectionWrapperComponent,
    GcInputFieldComponent,
    GcButtonComponent,
    SaveButtonsComponent,
    IpoTranslatePipe,
  ],
  templateUrl: './self-inspection-list.component.html',
  styleUrl: './self-inspection-list.component.scss',
})
export class SelfInspectionListComponent<T>
  extends SelfInspectionBaseClassComponent<T>
  implements OnInit
{
  @Input() wrapperData: SelfInspcetionWrapperData;
  @Input() data: ListInputData;

  @Output() clickIcon = new EventEmitter();
  @Output() saveInputs = new EventEmitter<T>();

  inputValues: string[] = [];
  savedInputValues: string[] = [];
  displayButtons = false;

  ngOnInit(): void {
    // Calling super.ngOnInit() to invoke the base class's ngOnInit lifecycle hook,
    // which contains shared initialization logic and functionality for getting the selfInspectionId.
    super.ngOnInit();
    this.createInputValues();
  }

  get selfInspectionId(): string {
    return this.data.id;
  }

  createInputValues() {
    const { requiredFieldsAmount, values } = this.data;

    this.inputValues = [...values];

    const fieldsToAdd = Math.max(0, requiredFieldsAmount - values.length);
    for (let i = 0; i < fieldsToAdd; i++) {
      this.addInputField();
    }

    if (!this.inputValues.length) {
      this.addInputField();
    }

    this.savedInputValues = [...this.inputValues];
  }

  addInputField() {
    this.inputValues.push('');
  }

  handleOnChangeInput(input: string, index: number) {
    this.inputValues[index] = input;
    this.displayButtons = true;
  }

  handleOnDelete(index: number) {
    this.inputValues.splice(index, 1);
    this.displayButtons = true;
  }

  handleOnClickCancel() {
    this.inputValues = [...this.savedInputValues];
    this.displayButtons = false;
  }

  handleOnClickSave() {
    this.saveValues(this.filterEmptyInputValues([...this.inputValues]));
    this.displayButtons = false;
  }

  saveValues(values: string[]) {
    this.setIsLoadingTrue();
    this.saveInputs.emit({ listTexts: values } as T);
    this.data.values = [...values];
    this.inputValues = values.length ? [...values] : [''];
    this.savedInputValues = [...this.inputValues];
  }

  showAddMoreButton(): boolean {
    return (
      !this.inputValues.some((value) => value.trim().length === 0) &&
      (!this.data.maximumFieldsAmount ||
        this.inputValues.length < this.data.maximumFieldsAmount)
    );
  }

  filterEmptyInputValues(values: string[]): string[] {
    return values.filter((value) => this.controlEmptyInputValue(value));
  }

  controlEmptyInputValue(value: string): boolean {
    return !!value.replace(/\s/g, '').length;
  }
}
